import firebase from '../../../../../../../firebase';

const addingGoogleMapsItem = lazyDataId => ({
  type: 'ADDING_GOOGLE_MAPS_ITEM',
  key: lazyDataId,
});

const reportErr = (lazyDataId, err) => ({
  type: 'GOOGLE_MAPS_ITEM_ERROR',
  key: lazyDataId,
  err,
});

const rearrangeGoogleMapsItem = (id, siblingId) => ({
  type: 'REARRANGE_GOOGLE_MAPS_ITEM',
  id,
  siblingId,
});

export const fieldChange = (appname, dataId, field, value) => {
  const dataRef = firebase
    .database()
    .ref(`apps/${appname}/draft/lazy_data/${dataId}`);

  dataRef.child(field).set(value);

  return {
    type: 'GOOGLE_MAPS_FIELD_CHANGE',
    appname,
    dataId,
    field,
    value,
  };
};

export const addGoogleMapsItem = (appname, dataId, title) => dispatch => {
  const dataRef = firebase
    .database()
    .ref(`apps/${appname}/draft/lazy_data/${dataId}`);

  const baseItem = {
    address: 'Edinburgh',
    title,
  };

  dispatch(addingGoogleMapsItem(dataId));

  const itemRef = dataRef.child('markers/chunks').push(baseItem);

  return dataRef
    .child('markers/order')
    .transaction(items => {
      if (!items) return [itemRef.key];

      return items.concat(itemRef.key);
    })
    .catch(err => dispatch(reportErr(err)));
};

const findIndex = (array, element) => {
  if (element === null) {
    return array.length;
  }

  return array.indexOf(element);
};

const moveArray = (oldIndex, newIndex, arr) => {
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
  return arr;
};

export const rearrangeItems = (
  appname,
  lazydata,
  id,
  siblingId,
) => dispatch => {
  const itemsRef = firebase
    .database()
    .ref(`apps/${appname}/draft/lazy_data/${lazydata}/markers/order`);

  itemsRef
    .transaction(array => {
      if (array === null) return null;

      const oIndex = findIndex(array, id);
      let nIndex = findIndex(array, siblingId);

      if (nIndex > oIndex) {
        nIndex -= 1;
      }

      return moveArray(oIndex, nIndex, array);
    })
    .then(dispatch(rearrangeGoogleMapsItem(id, siblingId)));
};
